// extracted by mini-css-extract-plugin
export default {"root":"LanguagePill_root__SeqYX","icon":"LanguagePill_icon__vnKb1","caret":"LanguagePill_caret__uJUK8","hidden":"LanguagePill_hidden__MbsxU"};